// extracted by css-extract-rspack-plugin
export default {"pill":"_6c6c1e1","pillDesktop":"_25e9eed3","pillMobile":"_3deec9a1"};